// extracted by mini-css-extract-plugin
export var currencyInput = "_mw-1";
export var currencySymbol = "_mw-0";